// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    fileEndpoint: 'https://s3.amazonaws.com/syscap-motto',
    //devApiEndpoint: 'http://api.motto.test/api',
    //devApiAuthEndpoint: 'http://api.motto.test/api/auth',
    devApiEndpoint: 'https://apimotto.syscap.com.mx/api',
    devApiAuthEndpoint: 'https:/apimotto.syscap.com.mx/api/auth',
};




// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/environments/environment.ts